import {http} from '@/core/init';

export default {
    namespaced: true,
    state: {
        client: "",
        ok: false
    },

    getters: {
        getClient: (state) => {
            return state.client;
        }
    },

    mutations: {
        SET_CLIENT: (state, payload) => {
            state.client = payload.result
        },
        SET_OK: (state) => {
            state.ok = true
        },
    },

    actions: {
        get: async ({commit}, rfc) => {
            let {data} = await  http.get('/clientes/'+rfc);
            commit('SET_CLIENT', data)
        },

        validateRfc: async ({commit}, rfc) => {
            await http.get('/validarrfc/' + rfc);
            commit('SET_OK')


        },

    }

}